"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PublishData = /** @class */ (function () {
    function PublishData(widgetId, pageId, title, url, schedule, exportMeta, statusId) {
        if (statusId === void 0) { statusId = 1; }
        this.widgetId = widgetId;
        this.pageId = pageId;
        this.title = title;
        this.url = url;
        this.schedule = schedule;
        this.exportMeta = exportMeta;
        this.statusId = statusId;
    }
    PublishData.prototype.deserialize = function (jsonObject) {
        this.widgetId = jsonObject.widgetId;
        this.id = jsonObject.id;
        this.title = jsonObject.title;
        this.statusId = jsonObject.statusId;
        this.url = jsonObject.url;
        var schedule = new Schedule();
        schedule.deserialize(jsonObject.schedule);
        this.schedule = schedule;
        this.exportMeta = jsonObject.exportMeta;
        this.pageId = jsonObject.pageId;
        this.publishedUserId = jsonObject.publishedUserId;
        this.updatedUserId = jsonObject.updatedUserId;
        this.dateCreated = jsonObject.dateCreated;
        this.dateUpdated = jsonObject.dateUpdated;
        this.cronExpression = jsonObject.cronExpression;
    };
    PublishData.prototype.serialize = function () {
        var jsonObject = {};
        jsonObject.widgetId = this.widgetId;
        jsonObject.title = this.title;
        jsonObject.statusId = this.statusId;
        jsonObject.schedule = this.schedule.serialize();
        jsonObject.exportMeta = this.exportMeta;
        jsonObject.url = this.url;
        jsonObject.pageId = +this.pageId;
        jsonObject.id = this.id;
        jsonObject.publishedUserId = null;
        jsonObject.updatedUserId = null;
        jsonObject.dateCreated = null;
        jsonObject.dateUpdated = null;
        jsonObject.cronExpression = null;
        return jsonObject;
    };
    return PublishData;
}());
exports.PublishData = PublishData;
var Schedule = /** @class */ (function () {
    function Schedule(periodicity, periodicityInterval, day, dayPositionInMonth, dayWithPosition, startTime, selectedOptionInMonthId) {
        if (periodicity === void 0) { periodicity = null; }
        if (periodicityInterval === void 0) { periodicityInterval = null; }
        if (day === void 0) { day = null; }
        if (dayPositionInMonth === void 0) { dayPositionInMonth = null; }
        if (dayWithPosition === void 0) { dayWithPosition = null; }
        if (startTime === void 0) { startTime = null; }
        if (selectedOptionInMonthId === void 0) { selectedOptionInMonthId = 1; }
        this.periodicity = periodicity;
        this.periodicityInterval = periodicityInterval;
        this.day = day;
        this.dayPositionInMonth = dayPositionInMonth;
        this.dayWithPosition = dayWithPosition;
        this.startTime = startTime;
        this.selectedOptionInMonthId = selectedOptionInMonthId;
    }
    Schedule.prototype.deserialize = function (jsonObject) {
        this.periodicityInterval = jsonObject.periodicityInterval;
        this.periodicity = jsonObject.periodicity;
        this.day = jsonObject.day;
        this.dayPositionInMonth = jsonObject.dayPositionInMonth;
        this.dayWithPosition = jsonObject.dayWithPosition;
        this.startTime = jsonObject.startTime;
        this.selectedOptionInMonthId = this.day ? 1 : 2;
    };
    Schedule.prototype.serialize = function () {
        var jsonObject = {};
        jsonObject.periodicityInterval = this.periodicityInterval;
        jsonObject.periodicity = this.periodicity;
        jsonObject.startTime = this.startTime;
        jsonObject.day = this.day;
        jsonObject.dayPositionInMonth = this.dayPositionInMonth;
        jsonObject.dayWithPosition = this.dayWithPosition;
        return jsonObject;
    };
    return Schedule;
}());
exports.Schedule = Schedule;
var Periodicity;
(function (Periodicity) {
    Periodicity["MINUTELY"] = "MINUTELY";
    Periodicity["HOURLY"] = "HOURLY";
    Periodicity["DAILY"] = "DAILY";
    Periodicity["MONTHLY"] = "MONTHLY";
})(Periodicity = exports.Periodicity || (exports.Periodicity = {}));
var DayPosInMonth;
(function (DayPosInMonth) {
    DayPosInMonth["FIRST"] = "FIRST";
    DayPosInMonth["LAST"] = "LAST";
})(DayPosInMonth = exports.DayPosInMonth || (exports.DayPosInMonth = {}));
var DayOfMonth;
(function (DayOfMonth) {
    DayOfMonth["MONTHDAY"] = "DAY";
})(DayOfMonth = exports.DayOfMonth || (exports.DayOfMonth = {}));
//# sourceMappingURL=publish-data.model.js.map